import {inject, reactive} from "vue";

class Notifications {
    app;
    _list = reactive({});
    events = {
        add: [],
        open: [],
        close: [],
    };
    settings = {
        maxNotifications: 2,
    };
    options = {
        title: null,
        message: null,
        type: 'info',
        duration: 3000,
        onClick: null,
        data: {},
        request: null,
        sound: null,
        color: null,
    };


    constructor(app, settings, messages = []) {
        this.app = app;
        this.settings = Object.assign(this.settings, settings);
        messages.forEach(m => this.notify(m));
    }

    all() {
        return Object.values(this._list);
    }

    on(name, callback) {
        if (typeof this.events[name] === 'undefined') return;
        const index = this.events[name].indexOf(callback);
        if (index !== -1) return;
        this.events[name].push(callback);
    }

    off(name, callback) {
        if (typeof this.events[name] === 'undefined') return;

        if (!callback) {
            this.events[name] = [];
            return;
        }

        const index = this.events[name].indexOf(callback);
        if (index === -1) return;
        this.events[name].splice(index, 1);
    }

    emit(name, notification) {
        if (typeof this.events[name] === 'undefined') return;
        this.events[name].forEach(callback => callback(notification));
    }

    notify(options = {}) {
        options = Object.assign({ ...this.options }, options);
        options.id = options.id || Date.now() + Math.random(0, 100);

        if (typeof options?.duration === 'undefined') {
            options.duration = this.options.duration;
        }

        if (options.duration) {
            options.duration = parseInt(options.duration);
        }

        this.emit('add', options);
        this._list[options.id] = options;
    }

    close(id) {
        if (typeof this._list[id] === 'undefined') return;
        this.emit('close', this._list[id]);
        delete this._list[id];
    }

    info(title, message, duration) {
        this.notify({
            title: message ? title : null,
            message: message ? message : title,
            type: 'info',
            duration
        });
    }

    error(title, message, duration) {
        this.notify({
            title: message ? title : null,
            message: message ? message : title,
            type: 'error',
            duration
        });
    }

    warning(title, message, duration) {
        this.notify({
            title: message ? title : null,
            message: message ? message : title,
            type: 'warning',
            duration
        });
    }

    success(title, message, duration) {
        this.notify({
            title: message ? title : null,
            message: message ? message : title,
            type: 'success',
            duration
        });
    }

    download(request, title, message, callback) {
        this.notify({
            type: 'download',
            title: title,
            position: 'bottom_right',
            message: message,
            request,
            callback,
            duration: null,
        });
    }
}

export default {
    install(app, settings, messages = []) {
        const notifications = new Notifications(app, settings, messages);
        app.config.globalProperties.$notify = (t,m,d) => notifications.info(t, m, d);
        app.config.globalProperties.$success = (t,m,d) => notifications.success(t, m, d);
        app.config.globalProperties.$warning = (t,m,d) => notifications.warning(t, m, d);
        app.config.globalProperties.$error = (t,m, d) => notifications.error(t, m, d);
        app.config.globalProperties.$noty = (options = {}) => notifications.notify(options);
        app.config.globalProperties.$notifier = notifications;
        app.provide('notify', notifications);
    }
}

export function useNotify() {
    return inject('notify');
}